// @flow
import { useState } from "react";
import qs from "query-string";
import { useHistory, useLocation } from "react-router";
import { css } from "styled-components";
import {
  media,
  smallParagraph,
  mediumParagraph,
  TextInput,
  Checkbox,
} from "@nested/brand";
import { Button } from "@nested/component-library";
import { getConfig } from "@nested/config";
import { triggerZapierWebhook } from "@nested/utils";
import {
  composeValidators,
  validatePresence,
  validateEmail,
} from "../questions/validators";
import { Heading, BackButton, QuestionWrapper } from "../components";

const { COMING_SOON_ZAP_ID } = getConfig();

const validate = composeValidators(
  validatePresence("email", "Please enter a valid email address"),
  validateEmail("email", "Please enter a valid email address"),
);

const errorStyles = css`
  ${smallParagraph}
  color: ${({ theme }) => theme.palette.terracotta100};
  font-weight: 500;
  line-height: 17px;
  margin-top: 0;
  ${media.tablet`
    margin-top: 14px;
  `}
`;

export const ComingSoonThankYou = () => {
  const history = useHistory();
  return (
    <QuestionWrapper>
      <BackButton
        prev={() => {
          history.push("/");
        }}
      />
      <Heading>
        Thanks for your details, please check your email for our selling guide.
      </Heading>
    </QuestionWrapper>
  );
};

export const ComingSoon = () => {
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [error, setError] = useState();
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const history = useHistory();
  const { search } = useLocation();
  const { postcode, addressId } = qs.parse(search);

  const onSubmit = async () => {
    try {
      setButtonDisabled(true);
      const emailValidation = await validate(email);
      if (emailValidation.email) {
        setError(emailValidation.email);
        return;
      }

      await triggerZapierWebhook(COMING_SOON_ZAP_ID, {
        email,
        consent,
        postcode,
        addressId,
      });

      setError(undefined);
      history.push("/get-started/coming-soon/thank-you");
    } catch (e) {
      setError("Sorry, something went wrong. Please try again.");
    } finally {
      setButtonDisabled(false);
    }
  };

  return (
    <QuestionWrapper
      className="CreateProspectForm"
      next={(e) => {
        e.preventDefault();
        onSubmit();
      }}
    >
      <BackButton
        prev={() => {
          history.push("/");
        }}
      />
      <Heading>Coming Soon!</Heading>
      <p css={mediumParagraph}>
        We're working on bringing our service to your area, but in the meantime,
        please enjoy our Ultimate Guide to Selling Your Home. Sign up below for
        answers to questions like:
      </p>
      <ul css={mediumParagraph}>
        <li> What’s my house worth?</li>
        <li>When is the perfect time to sell?</li>
        <li>How to add value before selling?</li>
        <li>How to pick the right estate agent</li>
      </ul>
      <TextInput
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Email address"
        type="email"
        className="fs-exclude"
        label="Email address"
        data-test="coming-soon:email"
      />
      <Checkbox
        css="margin-top: 20px;"
        label="Send me emails relating to Nested and the housing market"
        checked={consent}
        onChange={(e) => setConsent(e.target.checked)}
        data-test="coming-soon:consent"
      />
      {error && <p css={errorStyles}>{error}</p>}
      <Button
        data-test="coming-soon:submit"
        disabled={buttonDisabled}
        css="margin-top: 20px;"
        type="primary"
      >
        Submit
      </Button>
    </QuestionWrapper>
  );
};
